module.exports = __webpack_public_path__ + "img/69_17.42b18eaf.png";